export const config = {
    environment: 'local',
    apiUrl: 'http://localhost:5000',

    // Azure AD Authentication
    azureClientId: '987c59bd-28f8-4044-9533-2c797df27ec5',
    azureTenantId: '6e06e42d-6925-47c6-b9e7-9581c7ca302a',
    msalRedirectUri: 'http://localhost:3000',

    // Azure AD Security Groups (UAT groups for local testing)
    adminGroupId: 'a8ba5c77-63fb-49d8-98db-617bb1335b56',
    requestorGroupId: '6cbccd42-93fd-4cca-b33b-115813e80204',

    // GIAM groups: ODM_PM_ASSIGNMENT gates the Assign PM button,
    // ODM_COMMERCIAL_MANAGER gates the Commercial Manager quote-approval panel
    pmAssignmentGroupId: '9291487f-7081-413e-9cc8-55235238a482', // ODM_PM_ASSIGNMENT
    commercialManagerGroupId: 'd15580d7-a0db-42da-862c-895caadc928b' // ODM_COMMERCIAL_MANAGER
};
